import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import PageLogin from "./pages/pageLogin";
import AppPane from "./components/appPane";

import Home from "./pages/pageHome";
import Management from "./pages/pageManagement";
import Transition from "./pages/pageTransition";
import "./App.css";
import OrderList from "./pages/pageOrderList";
import { REQ_AUTH_USER, useApi } from "./logic/classApi";
import { LoginContext } from "./context/loginContext";
import Loading from "./components/loading";

const NotFound = () => <h1>404 - Page Not Found</h1>;

const App: React.FC = () => {
  const { postRequestJson } = useApi(window);
  const [isApiLoading, setApiLoading] = useState(true);
  const [isLogin, setIsLogin] = useState(false);
  const loginContext = { isLogin, setIsLogin };
  // ログイン
  useEffect(() => {
    (async () => {
      try {
        const { status } = await postRequestJson(REQ_AUTH_USER, {});
        if (status !== 200) {
          // セッションによる自動ログインの失敗なのでエラーメッセージは出さない
          setIsLogin(false);
        } else {
          setIsLogin(true);
        }
      } catch (e) {
        setIsLogin(false);
      }
      setApiLoading(false);
    })();
  }, []);

  const redirect = () => {
    window.history.pushState({}, "", "/home");
  };

  return (
    <AppPane>
      {isApiLoading ? (
        <Loading />
      ) : (
        <LoginContext.Provider value={loginContext}>
          {isLogin ? <MainContent /> : <PageLogin redirect={redirect} />}
        </LoginContext.Provider>
      )}
    </AppPane>
  );
};

function MainContent() {
  // 表示中の子ウィンドウ
  const [subWindows, setSubWindows] = useState<Window[]>([]);

  // 子ウィンドウ表示通知
  const handleOpenSubWindow = (window: Window) => {
    setSubWindows([...subWindows, window]);
  };

  // ログアウト通知
  const handleLogout = () => {
    // 子ウィンドウを開いている場合は全て閉じる
    subWindows.forEach(w => w?.close());
    // 閉じた子ウィンドウをクリア
    setSubWindows([]);
  };

  // ページアンロード前処理
  const handleBeforeUnload = () => {
    // 子ウィンドウを開いている場合は全て閉じる
    subWindows.forEach(w => w?.close());
  };

  useEffect(() => {
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [handleBeforeUnload]);

  return (
    <Router>
      <Routes>
        <Route path={"/"} element={<Navigate to={"/home"} />} />{" "}
        {/* 認証済みの場合は権限によりホームか管理画面へリダイレクト */}
        <Route path={"/login"} element={<Navigate to={"/home"} />} />{" "}
        {/* 認証済みの場合は権限によりホームか管理画面へリダイレクト */}
        <Route path={"/home"}>
          <Route
            index={true}
            element={
              <Home
                showHeader
                showSidebar
                onOpenSubWindow={handleOpenSubWindow}
                onLogout={handleLogout}
              />
            }
          />
          <Route path={":chemicalId"} element={<Transition />} />
        </Route>
        <Route
          path={"/management"}
          element={<Management showHeader showSidebar onLogout={handleLogout} />}
        />
        <Route
          path={"/orderlist"}
          element={<OrderList showHeader showSidebar onLogout={handleLogout} />}
        />
        <Route path={"*"} element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
